import React from "react";
import { FaTruck, FaLeaf } from "react-icons/fa";
import "./AboutHome.css";
import aboutImage from "../../assets/about (1).png";

const AboutHome = () => {
  return (
    <section className="about-home">
      <div className="about-home-content">
        <h3 className="about-home-entrada">QUALIDADE GARANTIDA</h3>
        <p className="about-home-title">
          Você escolhe o tamanho ideal para sua família<span className="period">.</span>
        </p>
        <p className="about-home-description">
          Nosso mel é cuidadosamente produzido de forma artesanal, respeitando métodos sustentáveis e a tradição familiar. Rico em nutrientes e propriedades benéficas, é perfeito para adoçar seu dia com naturalidade.
        </p>
        <a href="#produtos" className="about-home-link">
          ESCOLHA UM MODELO
        </a>
        <div className="about-home-delivery">
          <div className="delivery-item">
            <FaTruck className="delivery-icon" />
            <h4 className="delivery-title">Entregas</h4>
            <p className="delivery-description">
              Entregamos seu mel com rapidez e segurança, garantindo frescor e qualidade em cada pedido.
            </p>
          </div>
          <div className="delivery-item">
            <FaLeaf className="delivery-icon" />
            <h4 className="delivery-title">Origem Natural</h4>
            <p className="delivery-description">
              Os apiários estão localizados no distrito de 3 Corregos, interior de Campo Largo, nas margens do Rio Jacuí.
            </p>
          </div>
        </div>
      </div>
      <img src={aboutImage} alt="Sobre Nós" className="about-home-image" />
    </section>
  );
};

export default AboutHome;
